import { ua } from './modules/ua'
import { entranceAnimation } from './modules/entranceAnimation'
import { setShopViewData } from './modules/common'
import { shopInit } from './modules/shop'
import { Util } from './modules/vue/master'
import { inquiryShopListSet } from './modules/inquiryShopList'

class App {
  constructor() {
    this.body = document.querySelector('body')
    this.params = new URLSearchParams(window.location.search)
    this.init()
  }

  init() {
    // 全ページ共通適用
    this.body.classList.add(`is-${ua.browser()}`)
    this.body.classList.add(`is-${ua.os()}`)
    entranceAnimation()
    setShopViewData()
    shopInit()

    window.addEventListener('resize', () => {})
    window.addEventListener('scroll', () => {})

    if (document.querySelector('.navigation-trigger')) {
      document.querySelector('.navigation-trigger').addEventListener('click', () => {
        if (document.querySelector('.navigation-trigger').getAttribute('data-shop') == 'true') {
          this.body.classList.toggle('view-shop-navigation')
        } else {
          this.body.classList.toggle('view-navigation')
        }
      })
    }

    Array.from(document.querySelectorAll('.global-footer__nav dt')).forEach((item) => {
      item.addEventListener('click', () => {
        item.classList.toggle('is-open')
      })
    })

    Array.from(document.querySelectorAll('[data-modal-trigger]')).forEach((item) => {
      item.addEventListener('click', () => {
        const target = `.${item.getAttribute('data-modal-target')}`
        this.body.classList.add('view-modal')
        document.querySelector(target).classList.add('is-open')
      })
    })

    Array.from(document.querySelectorAll('[data-close-target]')).forEach((item) => {
      item.addEventListener('click', () => {
        const target = `.${item.getAttribute('data-close-target')}`
        this.body.classList.remove('view-modal')
        document.querySelector(target).classList.remove('is-open')
      })
    })

    /**
     * その他のご案内ページ：諸費用明細表の出し分け
     */
    if (document.querySelector('[data-expenses-list]')) {
      const shopData = Util.DEALER.area
      const shopID = localStorage.getItem('shopID')
      let filterData = []

      shopData.forEach((area) => {
        // area.shops 内のアイテムで shop_id が shopIDと一致するものを取得
        const result = area.shops.filter((shop) => shop.shop_id == shopID)
        if (result.length > 0) {
          filterData.push(result[0])
        }
      })

      let expensedData = {
        pdf: filterData.length > 0 ? filterData[0].expenses_pdf : 'universal_certified-factory.pdf',
        img:
          filterData.length > 0 ? filterData[0].expenses_image : 'universal_certified-factory.png',
      }

      const expenseDetailsButton = document.querySelector('[data-expense-details-pdf]')
      const pdfUrl =
        '/wp-content/themes/HDJ2024_v1/assets/img/service/other-service/' + expensedData.pdf

      expenseDetailsButton.setAttribute('href', pdfUrl)

      const expenseDetailsImage = document.querySelector('[data-expense-details-image]')
      const imageUrl =
        '/wp-content/themes/HDJ2024_v1/assets/img/service/other-service/' + expensedData.img

      expenseDetailsImage.setAttribute('src', imageUrl)
    }

    /**
     * お問い合わせフォーム：shopIDから店舗を選択
     */
    inquiryShopListSet()

    /**
     * お問い合わせページ：アコーディオン開閉処理
     */
    if (document.querySelector('.inquiry-accordion')) {
      const accordionTarget = document.querySelectorAll('[data-accordion-target]')

      function accordionToggle() {
        const accordionContent = this.nextElementSibling
        accordionContent.classList.toggle('is-open')

        const accordionTarget = this
        accordionTarget.classList.toggle('is-open')
      }

      for (let i = 0; i < accordionTarget.length; i++) {
        accordionTarget[i].addEventListener('click', accordionToggle)
      }
    }

    /**
     * お問い合わせページ：フォーム表示非表示切り替え
     */
    if (document.querySelector('.inquiry-purpose')) {
      const oppositionFormButton = document.querySelector('[data-opposition-form-button]')
      const approvalFormButton = document.querySelector('[data-approval-form-button]')
      const oppositionFormContent = document.querySelector('[data-opposition-form-content]')
      const approvalFormContent = document.querySelector('[data-approval-form-content]')
      const approvalHiddenContent = document.querySelector('[data-approval-hidden-content]')

      oppositionFormButton.addEventListener('click', () => {
        oppositionFormContent.classList.remove('is-hidden')
        approvalFormContent.classList.add('is-hidden')
      })

      approvalFormButton.addEventListener('click', () => {
        approvalFormContent.classList.remove('is-hidden')
        oppositionFormContent.classList.add('is-hidden')
        approvalHiddenContent.classList.add('is-hidden')
      })

      // wpcf7から始まるアンカーリンクの指定がある場合、アコーディオンを開く
      const url = location.href
      const hash = url.split('#')[1]
      // hashにテキストwpcf7が含まれる場合
      if (hash && hash.includes('wpcf7')) {
        approvalFormContent.classList.remove('is-hidden')
        oppositionFormContent.classList.add('is-hidden')
        approvalHiddenContent.classList.add('is-hidden')
      }

      const pdfUrl = this.params.get('pdf')
      const birthdayInput = document.querySelector('[name="fld-birthday"]')
      const birthdayCheck = document.querySelector('[name="fld-birthday-check[]"]')
      // パラメータにpdf=の内容がある場合のみ以下実行
      if (pdfUrl == null) {
        document.querySelector('.field-set.is-birthday dt small').remove()
      }

      if (birthdayCheck && pdfUrl == null) {
        birthdayCheck.checked = true
      } else if (birthdayCheck && pdfUrl != null) {
        birthdayCheck.checked = birthdayInput.value != ''
        birthdayInput.addEventListener('change', (e) => {
          let val = e.target.value
          birthdayCheck.checked = val != ''
        })
      }
    }

    /**
     * お問い合わせページ：PDFファイルのURLをメッセージ欄にセット
     */
    const messageField = document.querySelector('[name="fld-message"]')
    const pdfUrl = this.params.get('pdf')
    if (messageField && pdfUrl) {
      const messageFieldText = `下記をご記入ください。\n\n■来店予約希望日時\n第一希望日:  月  日  時ごろ\n第二希望日:  月  日  時ごろ\n第三希望日:  月  日  時ごろ\n※予約希望日時はご希望に添えない場合がございます。\n\n■簡易見積もりPDF\n${pdfUrl}\n\n■その他ご要望があればご記入ください\n\n`
      messageField.value = messageFieldText
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.app = new App()
})

window.addEventListener('load', () => {})
